import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import FormControl from 'components/Core/FormControl';
import { Col, Row } from 'components/Core/Grid';
import Button from 'components/Core/Button';
import FormTextField from 'components/Page/Toolbox/FormTextField';
import { getFormValid } from 'utils/formUtils';
import { SignupContainer } from './styles';

const Signup3 = ({ onFinish, errorMessage, data = {}, ...otherProps }) => {
  const { values, handleChange, handleBlur, handleSubmit, errors, isValid, touched, submitCount } =
    otherProps;

  const formValid = getFormValid({ errors, submitCount });

  return (
    <SignupContainer>
      <h4>Complete Your Account Details</h4>
      <div>
        <FormTextField
          id="firstName"
          placeholderText="First Name"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          formValid={formValid}
          formErrors={errors}
        />
        <FormTextField
          id="lastName"
          placeholderText="Last Name"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          formValid={formValid}
          formErrors={errors}
        />
        <FormTextField
          id="company"
          placeholderText="Company"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          formValid={formValid}
          formErrors={errors}
        />
        <FormTextField
          id="phone"
          placeholderText="Phone Number"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          type="number"
          format="(###) ###-####"
          formValid={formValid}
          formErrors={errors}
        />
        {errorMessage && (
          <FormControl>
            <p>
              <span className="input-failed-value">{errorMessage}</span>
            </p>
          </FormControl>
        )}
        <Row>
          <Col md={24}>
            <Button
              type="secondary"
              width="100%"
              shadow={false}
              button
              disabled={!isValid}
              onClick={handleSubmit}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </div>
    </SignupContainer>
  );
};

const vSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('First Name is required').nullable(),
  lastName: Yup.string().trim().required('Last Name is required').nullable(),
  phone: Yup.string().required('Phone is required').min(14, 'Phone must be 10 numbers').nullable(),
  company: Yup.string().trim().required('Company is required').nullable(),
});

export default withFormik({
  validationSchema: vSchema,
  mapPropsToValues: ({ data }) => data,
  handleSubmit: (values, { props, setErrors }) => {
    props.onFinish(values);
  },
})(Signup3);
